import Image from 'next/image';

import { AppStoreButtons } from '../Clickables/Buttons/AppStoreButtons/AppStoreButtons';
import { Heading } from '../Heading/Heading';
import { Source } from '../NextImage/Source';
import { QRCode } from '../QRCode/QRCode';
import { Text } from '../Text/Text';
import { useIsTabletScreenWidthOrWider } from '../../helpers/hooks/useScreenWidth';
import BitetimeSectionBackground from './assets/bitetime-section-background.png';
import { DynamicTopSpeciesProps } from './constants/constants';
import { twMerge } from 'tailwind-merge';

interface IBitetimeDownloadSectionProps {
  className?: string;
  text?: string;
  title: string;
  topSpecies: DynamicTopSpeciesProps;
}

export const BitetimeDownloadSection = ({
  className,
  text,
  title = 'When is the best time to fish?',
  topSpecies,
}: IBitetimeDownloadSectionProps) => {
  const isTabletScreenWidthOrWider = useIsTabletScreenWidthOrWider();

  return (
    <div
      className={twMerge(
        `relative grid grid-rows-none rounded-lg bg-lake-fog bg-contain bg-bottom bg-no-repeat sm:grid-cols-12 md:col-span-10 md:col-start-2 md:grid-cols-10`,
        className,
      )}
    >
      <div className="z-2 col-start-1 row-start-1 flex flex-col justify-end px-4 pb-0 pt-6 sm:col-span-6 sm:col-start-7 sm:pl-0 sm:pr-8 sm:pt-12 md:col-span-5 md:col-start-6 md:m-0 md:justify-between md:pt-11">
        <div>
          <Heading as="h2" variant="md" className="mb-3 sm:mt-auto">
            {title}
          </Heading>
          {text && (
            <Text variant="md" className="mb-0 font-normal">
              {text}
            </Text>
          )}
        </div>
        {isTabletScreenWidthOrWider && (
          <div className="hidden w-full justify-end pb-6 pt-8 sm:flex md:justify-end md:py-6">
            <QRCode showOnMobileDevice className="rounded-md bg-sea-foam p-2" source="bite-time" />
          </div>
        )}
      </div>
      <div className="z-2 col-start-1 row-start-2 flex items-end justify-center px-4 pt-4 sm:col-span-6 sm:col-start-1 sm:row-start-1 sm:px-2 sm:pt-8 md:col-span-5 md:px-8 md:pt-11">
        <picture>
          <Source media="(min-width: 990px)" src={topSpecies.biteTimeImgDesktop}></Source>
          <Source media="(min-width: 600px)" src={topSpecies.biteTimeImgTablet}></Source>
          <Image
            alt="Bite time image"
            className="w-full"
            src={topSpecies.biteTimeImgMobile}
            height={topSpecies.biteTimeImgMobile.height}
            width={topSpecies.biteTimeImgMobile.width}
          />
        </picture>
      </div>
      {!isTabletScreenWidthOrWider && (
        <div
          style={{
            background: 'linear-gradient(180deg, rgba(245, 246, 247, 0) 0%, #F3F3F3 92.19%)',
          }}
          className={`z-mid col-start-1 row-start-2 ml-auto mt-auto flex w-full justify-end rounded-b-lg px-6 pb-4 pt-8 sm:hidden`}
        >
          <AppStoreButtons source="bite-time" />
        </div>
      )}
      <div className="absolute inset-x-0 bottom-0 z-1 hidden md:flex">
        <Image alt="Bite time background" className="w-full" src={BitetimeSectionBackground} />
      </div>
    </div>
  );
};
